import { Tag } from 'antd';
import { CREATION_MODES } from '../productStudioModes';

// ─────────────────────────────────────────────────────────────────
// Mode picker — Quick / Guided / Advanced.
// Renders as 3 horizontal pill cards. Pure controlled component.
// ─────────────────────────────────────────────────────────────────

export default function ProductStudioModeSelector({ value, onChange }) {
  return (
    <div
      className="erp-studio-mode-picker"
      role="radiogroup"
      aria-label="Creation mode"
    >
      {CREATION_MODES.map((mode) => {
        const active = value === mode.key;
        return (
          <button
            key={mode.key}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(mode.key)}
            className={`erp-studio-mode-card ${active ? 'is-active' : ''}`}
          >
            <div className="erp-studio-mode-card__title">
              <span>{mode.label}</span>
              {mode.tagline ? (
                <Tag
                  color={mode.key === 'quick' ? 'blue' : 'default'}
                  style={{ marginLeft: 8, fontSize: 10.5, padding: '0 6px', lineHeight: '16px' }}
                >
                  {mode.tagline}
                </Tag>
              ) : null}
            </div>
            <div className="erp-studio-mode-card__desc">{mode.description}</div>
          </button>
        );
      })}
    </div>
  );
}
